import React, { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'lib/languages/useTranslate';
import { getCardsIsPosting } from 'lib/selectors/cards';

interface CarouselButtonsProps {
    onViewPinClick: () => void;
    toggleFreeze: () => void;
    isFrozen: boolean;
    isDisabledCard: boolean;
    remainingSeconds: number;
    isCountdownActive: boolean;
}

const CarouselButtons: FC<CarouselButtonsProps> = ({
    onViewPinClick,
    toggleFreeze,
    isFrozen,
    isDisabledCard,
    remainingSeconds,
    isCountdownActive,
}) => {
    const translate = useTranslate('cards');

    const isPosting = useSelector((state: any) =>
        getCardsIsPosting(state),
    ) as boolean;

    const getFreezeButtonText = (): ReactNode => {
        if (isCountdownActive) {
            return remainingSeconds;
        }
        if (isFrozen) {
            return translate('unfreezeCard');
        }
        return translate('freezeCard');
    };

    const isButtonFreezeUnfreezeDisabled =
        isDisabledCard || isCountdownActive || isPosting;

    return (
        <div className="carousel-button-container flex center">
            <div className="button-container">
                <div className="buttons">
                    <Button
                        onClick={onViewPinClick}
                        disabled={isDisabledCard}
                        tracking
                        trackingLabel="VIEW_PIN"
                    >
                        <i className="icon fa fa-th" />
                        {translate('viewPin')}
                    </Button>
                    <Button
                        disabled={isButtonFreezeUnfreezeDisabled}
                        isPosting={isPosting}
                        onClick={toggleFreeze}
                        className={`${isFrozen ? 'unfreeze' : 'freeze'}`}
                        tracking
                        trackingLabel={`${
                            isFrozen ? 'UNFREEZE' : 'FREEZE'
                        }_CARD`}
                    >
                        <i
                            className={`icon fa fa-${
                                isFrozen ? 'unlock' : 'lock'
                            }-alt`}
                        />
                        <span>{getFreezeButtonText()}</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CarouselButtons;
